<template>
  <v-app>
    <!-- clipped-left ignores the the gap created by nav drawer -->
    <v-app-bar app clipped-left dense v-if="showAppBar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="showDrawerBtn"></v-app-bar-nav-icon>

      <img src="/icon.png" style="height:32px;width:32px" class="pa-1" />
      <v-toolbar-title class="headline">
        <span class="headline pl-2 pr-2 d-sm-inline d-none">{{config.name}}</span>
      </v-toolbar-title>
      <span class="subtitle-1 grey--text pt-1 d-md-inline d-none"> {{pageTitle}}</span>

      <v-spacer></v-spacer>

      <v-subheader class="pl-2">
        <span class="d-lg-inline d-none pr-2">{{config.company.name}}</span>
        <span class="d-lg-inline d-none pr-2">{{config.version}} (API {{backendVersion}})</span>
      </v-subheader>
      <v-btn
        text
        to="/signin"
        v-if="!isLoggedIn"
        :disabled="$route.path == '/signin'"
        color="primary"
      >Sign In</v-btn>
      <template v-if="isLoggedIn">
        <v-btn text to="/account">
          <v-icon left color="primary">account_circle</v-icon>
          {{$store.state.user.firstName}}
        </v-btn>

        <v-btn text @click="signout">
          <span class="mr-2">Sign Out</span>
        </v-btn>
      </template>
      <v-btn text @click="openHelp" :disabled="!helpFound">
        <v-icon medium left color="primary">help</v-icon>help
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      app
      clipped
      disable-route-watcher
      mobile-break-point="800"
      v-model="drawer"
    >
      <v-list dense tile nav>
        <template v-for="(o, i) in menuComputed">
          <v-list-group dense no-action v-if="o.type == 'group'" :key="i">
            <template v-slot:activator>
              <v-icon left>{{o.icon}}</v-icon>
              <v-list-item-title>{{o.name}}</v-list-item-title>
            </template>
            <template v-for="(o1, j) in o.items">
              <v-list-item :key="j" v-if="o1.type == 'link'" :to="o1.to" link>
                <v-list-item-title>{{o1.name}}</v-list-item-title>
                <v-icon right>{{o1.icon}}</v-icon>
              </v-list-item>
              <v-list-group sub-group dense no-action :key="j" v-if="o1.type == 'group'">
                <template v-slot:activator>
                  <v-icon left>{{o1.icon}}</v-icon>
                  <v-list-item-title>{{o1.name}}</v-list-item-title>
                </template>
                <v-list-item
                  v-for="(o2, k) in o1.items"
                  :key="k"
                  v-if="o2.type='link'"
                  :to="o2.to"
                  link
                >
                  <v-list-item-title>{{o2.name}}</v-list-item-title>
                  <v-icon right>{{o2.icon}}</v-icon>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list-group>
          <v-list-item v-if="o.type == 'link'" :key="i" :to="o.to" link>
            <v-icon left>{{o.icon}}</v-icon>
            <v-list-item-title>{{o.name}}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-content class="grey lighten-2">
      <v-container fluid pa-4 text-center ref="routecontainer">
        <router-view :showAppBar.sync="showAppBar"></router-view>
      </v-container>
    </v-content>
    <snackbar></snackbar>
    <AConfirmDialog></AConfirmDialog>
    <AMessageDialog></AMessageDialog>
    <AHelpDialog ref="helpDialog"></AHelpDialog>
  </v-app>
</template>

<script>
import _ from "lodash";
import snackbar from "./components/snackbar";
import authApi from "./api/auth";
import snackbarMixin from "./mixins/snackbar";
import AConfirmDialog from "./components/AConfirmDialog";
import AMessageDialog from "./components/AMessageDialog";
import AHelpDialog from "./components/AHelpDialog";
import EventBus from "./EventBus";
import axios from "../src/api/axios";
import { utils as routeUtils } from "./router";

export default {
  name: "App",
  mixins: [snackbarMixin],
  components: {
    snackbar,
    AConfirmDialog,
    AMessageDialog,
    AHelpDialog
  },
  data: () => ({
    backendVersion: "",
    pin: true,
    showAppBar: true,
    drawerInternal: true,
    disableNavIcon: false,
    group: null,
    drawerDisabledPages: ["/signin", "/recovery", "/password-reset"],
    defaultPagesPriority: [
      "/cart/scan",
      "/cart/scan-log",
      "/cart/live-locations",
      "/trackingorder/scan",
      "/trackingorder/log",
      "/about"
    ],
    menu: [
      {
        type: "group",
        name: "Transfer Order Tracking",
        icon: "check_circle",
        items: [
          {
            type: "link",
            name: "TO Scan",
            icon: "dock",
            to: "/trackingorder/scan"
          },
          {
            type: "link",
            name: "TO Scan Log",
            icon: "description",
            to: "/trackingorder/log"
          }
        ]
      },
      {
        type: "group",
        name: "Cart Tracking",
        icon: "shopping_cart",
        items: [
          {
            type: "link",
            name: "Scan",
            icon: "dock",
            to: "/cart/scan"
          },
          {
            type: "link",
            name: "Scan Log",
            icon: "description",
            to: "/cart/scan-log"
          },
          {
            type: "link",
            name: "Bill Of Lading",
            icon: "timer",
            to: "/cart/bill-of-lading"
          },
          {
            type: "link",
            name: "Cart Live Location",
            icon: "insert_chart",
            to: "/cart/live-locations"
          },
          {
            type: "link",
            name: "Mirror Zone",
            icon: "insert_chart",
            to: "/cart/mirror-zone"
          }
        ]
      },
      {
        type: "group",
        name: "Administration",
        icon: "settings",
        items: [
          {
            type: "group",
            name: "Manage Users & Roles",
            // icon: "people",
            items: [
              {
                type: "link",
                name: "Users",
                icon: "person_add",
                to: "/manage/users"
              },
              {
                type: "link",
                name: "Roles",
                icon: "group",
                to: "/manage/roles"
              }
            ]
          },
          {
            type: "group",
            name: "Manage Items",
            // icon: "shopping_cart",
            items: [
              {
                type: "link",
                name: "Transfer Orders",
                to: "/manage/trackingorders"
              },
              {
                type: "link",
                name: "Carts",
                to: "/manage/carts"
              },
              {
                type: "link",
                name: "Stations",
                to: "/manage/stations"
              },
              {
                type: "link",
                name: "Station Groups",
                to: "/manage/stationgroups"
              },
              {
                type: "link",
                name: "Work Centers",
                to: "/manage/work-centers"
              },
              {
                type: "link",
                name: "Modules",
                to: "/manage/modules"
              },
              {
                type: "link",
                name: "Contracts & Flows",
                to: "/manage/contracts"
              },
              {
                type: "link",
                name: "Locations",
                to: "/manage/locations"
              },
              {
                type: "link",
                name: "Mirror Zones",
                to: "/manage/mirrorzones"
              },
              {
                type: "link",
                name: "LHG",
                to: "/manage/lhgs"
              },
              {
                type: "link",
                name: "Line Move Dates",
                to: "/manage/linemovedates"
              },
              {
                type: "link",
                name: "States",
                to: "/manage/states"
              }
            ]
          },
          {
            type: "link",
            name: "Settings",
            icon: "settings",
            to: "/manage/settings"
          }
        ]
      },
      {
        type: "link",
        name: "Help",
        icon: "help",
        to: "/help"
      },
      {
        type: "link",
        name: "About",
        icon: "info",
        to: "/about"
      }
    ]
  }),
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    menuComputed: function() {
      return this.buildMenu(this.menu);
    },
    drawer: {
      get: function() {
        // Ensure navigation panel is disable if not signed in
        if (!this.showDrawerBtn) return false;
        return this.drawerInternal;
      },
      set: function(val) {
        this.drawerInternal = val;
      }
    },
    showDrawerBtn: function() {
      for (let i = 0; i < this.drawerDisabledPages.length; i++) {
        const p = this.drawerDisabledPages[i];
        if (this.$route.path == p) return false;
      }
      return true;
    },
    pageTitle: function() {
      return this.$route.meta && this.$route.meta.title
        ? this.$route.meta.title
        : "";
    },
    helpFound: function() {
      return this.$route.meta && this.$route.meta.help;
    }
  },
  watch: {
    $route: function(val) {
      // todo use a collection
      if (this.$route.path == "/signin" || this.$route.path == "/cart/mirror-zone") {
        this.drawer = false;
      } else {
        this.drawer = true;
      }
      document.title = this.config.name + " - " + this.pageTitle;
    }
  },
  mounted() {
    this.retreiveBackendVersion();
    if (ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        EventBus.$emit("ContainerResizedEvent", {});
      });
      this.resizeObserver.observe(this.$refs.routecontainer);
    }
  },
  methods: {
    retreiveBackendVersion() {
      axios.get("/version").then(r => {
        if (r.data.ok) {
          this.backendVersion = r.data.d;
        }
      });
    },
    buildMenu(originalMenu) {
      let menu = [];
      originalMenu.forEach(e => {
        if (e.type == "link") {
          if (routeUtils.userHasRoutePerm(e.to)) {
            menu.push({
              type: e.type,
              name: e.name,
              icon: e.icon,
              to: e.to
            });
          }
        }
        if (e.type == "group") {
          let submenu = this.buildMenu(e.items);
          if (submenu.length > 0) {
            menu.push({
              type: e.type,
              name: e.name,
              icon: e.icon,
              items: submenu
            });
          }
        }
      });
      return menu;
    },
    signout() {
      authApi.signout(data => {
        if (data.ok) {
          this.$store.commit("user/clear");
          this.$router.push("/signin");
        }
      });
    },
    openHelp() {
      if (this.helpFound) this.$refs.helpDialog.open(this.$route.meta.help);
    }
  }
};
</script>

<style>
.bottom-border {
  border-bottom: 1px solid #efefef;
}
</style>

<style lang="scss">
.centered {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 100%;
}
</style>